var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33366 8.33333C7.7939 8.33333 8.16699 8.70642 8.16699 9.16666V14.1667C8.16699 14.6269 7.7939 15 7.33366 15C6.87342 15 6.50033 14.6269 6.50033 14.1667V9.16666C6.50033 8.70642 6.87342 8.33333 7.33366 8.33333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5003 14.1667V9.16666C11.5003 8.70642 11.1272 8.33333 10.667 8.33333C10.2068 8.33333 9.83366 8.70642 9.83366 9.16666V14.1667C9.83366 14.6269 10.2068 15 10.667 15C11.1272 15 11.5003 14.6269 11.5003 14.1667Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83366 4.16666V3.33333C4.83366 2.67029 5.09705 2.0344 5.56589 1.56556C6.03473 1.09672 6.67062 0.833328 7.33366 0.833328H10.667C11.33 0.833328 11.9659 1.09672 12.4348 1.56556C12.9036 2.0344 13.167 2.67029 13.167 3.33333V4.16666H16.5003C16.9606 4.16666 17.3337 4.53976 17.3337 4.99999C17.3337 5.46023 16.9606 5.83333 16.5003 5.83333H15.667V16.6667C15.667 17.3297 15.4036 17.9656 14.9348 18.4344C14.4659 18.9033 13.83 19.1667 13.167 19.1667H4.83366C4.17062 19.1667 3.53473 18.9033 3.06589 18.4344C2.59705 17.9656 2.33366 17.3297 2.33366 16.6667V5.83333H1.50033C1.04009 5.83333 0.666992 5.46023 0.666992 4.99999C0.666992 4.53976 1.04009 4.16666 1.50033 4.16666H4.83366ZM6.7444 2.74407C6.90068 2.58779 7.11265 2.49999 7.33366 2.49999H10.667C10.888 2.49999 11.1 2.58779 11.2562 2.74407C11.4125 2.90035 11.5003 3.11231 11.5003 3.33333V4.16666H6.50033V3.33333C6.50033 3.11231 6.58812 2.90035 6.7444 2.74407ZM4.00033 5.83333V16.6667C4.00033 16.8877 4.08812 17.0996 4.2444 17.2559C4.40068 17.4122 4.61265 17.5 4.83366 17.5H13.167C13.388 17.5 13.6 17.4122 13.7562 17.2559C13.9125 17.0996 14.0003 16.8877 14.0003 16.6667V5.83333H4.00033Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.704747ffc3f4e8d6bfac4f402e287689.svg";
export { ForwardRef as ReactComponent };